import Form from '@form/Form';

export default class FormContext {
    constructor(config) {
        this.isLoaded = false;
        this.isLoading = 0;
        this.isEditable = false;
        this.isAlwaysInEditMode = false;
        this.handleEditModeByQuery = true;
        this.isInEditMode = false;
        Object.assign(this, config)

        this.form = new Form({});
        this.data = {};
        this.permissions = {};
        this.objectId = null;
        this.complexFields = {};
        this.permissions = {};
        this.subformIdentifiers = [];
    }
}
